import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.otherStructureExclusion.address',
        defaultMessage: 'Address'
    },
    description: {
        id: 'ml.quoteandbind.otherStructureExclusion.description',
        defaultMessage: 'Description of Excluded Structure(s)'
    },
    action: {
        id: 'ml.quoteandbind.otherStructureExclusion.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.otherStructureExclusion.modalTitle',
        defaultMessage: 'Add Excluded Other Structures'
    },
    addressLine1: {
        id: 'ml.quoteandbind.otherStructureExclusion.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.otherStructureExclusion.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.otherStructureExclusion.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.otherStructureExclusion.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.otherStructureExclusion.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.otherStructureExclusion.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.otherStructureExclusion.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.otherStructureExclusion.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.otherStructureExclusion.continueBtn',
        defaultMessage: 'Continue'
    },
});